<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-bind:showNavbar="p_showNavbar"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <!--pc端-->
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 我的订单</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>

        <el-container style="margin:10px 0 0 20px;">
          <el-header class="order mhide">订单列表

            <el-select style="float: right;width:120px;margin-right: 10px;" v-model="value" placeholder="请选择" @change="orderTypeChange" v-if="user.isChannel == 1 && user.channel.parentId == 0">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>



          </el-header>
          <el-main v-loading="loading">
            <el-row>
              <el-col :span="12" style="padding-top: 5px;">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{dateRange}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in dateRangeList" :key="index" :command="item.key">
                      {{item.value}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <!--<el-col :span="12" style="text-align: right">-->
              <!--<el-checkbox v-model="historyOrder" @change="getHistoryList" v-if="user.isChannel != 0">查看个人历史订单</el-checkbox>-->
              <!--</el-col>-->
              <div class="fr"><el-input
                v-model="keyword"
                placeholder="请输入商品名称或订单号开始搜索"
                style="width: 260px;vertical-align: middle;"
                @input="inputKey"
                @keyup.enter.native="search"
                clearable>
                <!--<a-->
                <!--class="el-icon-search"-->
                <!--slot="suffix"-->
                <!--@click="search">-->
                <!--</a>-->
              </el-input><el-button type="primary" @click="search">搜索</el-button></div>

            </el-row>




            <!--<div class="order-item" v-for="(item,index) in orderList">
              <div class="order-item-title">
                <span class="order_time">{{item.addTime}}</span>
                <span class="order_num">订单号：{{item.orderNum}}</span>
                <template v-if="item.orderType == 1">
                  <span class="ft_r" v-if="item.status == 0">未支付</span>
                  <span class="ft_r" v-else-if="item.status == 1">待发货</span>
                  <span class="ft_r" v-else-if="item.status == 2">已发货</span>
                  <span class="ft_r" v-else-if="item.status == 3">待录入样本</span>
                  <span class="ft_r" v-else-if="item.status == 4">录入中</span>
                  <span class="ft_r" v-else-if="item.status == 5">待确认</span>
                  <span class="ft_r" v-else-if="item.status == 6">已确认</span>
                  <span class="ft_r" v-else-if="item.status == 7">已送样</span>
                  <span class="ft_r" v-else-if="item.status == 8">已收样</span>
                  <span class="ft_r" v-else-if="item.status == 9">检测中</span>
                  <span class="ft_r" v-else-if="item.status == 10">报告生成</span>
                  <span class="ft_r" v-else-if="item.status == 11">支付超时</span>
                  <span class="ft_r" v-else-if="item.status == 12">取消订单</span>
                  <span class="ft_r" v-else-if="item.status == 13" style="color: #FE2042;">已拒绝</span>
                  <span class="ft_r" v-else>暂无</span>
                </template>
                <template v-else>
                  <span class="ft_r" v-if="item.courierList.length > 0">已发货</span>
                  <span class="ft_r" v-else>待发货</span>
                </template>
              </div>
              <el-table
                :data="item.orderDetailList"
                :span-method="objectSpanMethod"
                border
                style="width: 100%">
                <el-table-column
                  prop="itemName"
                  label="商品名称">
                </el-table-column>
                <el-table-column
                  prop="specPrice"
                  label="单价">
                </el-table-column>
                <el-table-column
                  prop="spec"
                  label="规格">
                </el-table-column>
                <el-table-column
                  prop="itemNum"
                  label="数量">
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作">
                  <template slot-scope="scope">
                    <span class="total-price">￥{{item.totalPrice | FormatCurrency(item.totalPrice)}}</span>
                    <el-button
                      @click.native.prevent="detailRow(item.id)"
                      type="text"
                      size="small"
                      style="display: block">
                      查看详情
                    </el-button>
                    <el-button
                      v-if="item.payStatus == 0 && item.sampleStatus != 2 && item.sampleStatus != 3 && item.sampleStatus != 10"
                      @click.native.prevent="deleteRow(item.id)"
                      type="text"
                      size="small"
                      style="display: block;color:#909399;">
                      取消订单
                    </el-button>
                    <el-button
                      v-if="item.payStatus == 2 && item.sampleStatus != 2 && item.sampleStatus != 3 && item.sampleStatus != 10"
                      @click.native.prevent="destroyRow(item.id)"
                      type="text"
                      size="small"
                      style="display: block;color:#909399;">
                      删除订单
                    </el-button>
                    <el-button
                      @click.native.prevent="toPay(item.id)"
                      type="text"
                      size="small"
                      v-if="item.payStatus == 0 && !isChannel"
                      style="color:#FE2042;">
                      去支付
                    </el-button>
                    <el-button
                      @click.native.prevent="addOrUpdateHandle(scope.row.id, scope.row.itemId, item.id)"
                      type="text"
                      size="small"
                      v-if="item.payStatus == 1 && item.orderType == 1 && !item.sampleIdList.length"
                      style="display: block">
                      录入样本信息
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>-->


            <div class="order-item" v-for="(item,index) in orderList">
              <div class="order-item-title">
                <!--<span class="order_time">{{item.addTime}}</span>-->
                <span class="order_num">订单号：{{item.orderNum}}</span>
                <template v-if="isChannel">
                  <!--非个人-->
                  <template v-if="item.status || item.status == 0">
                    <span class="ft_r">{{statusTag(item.status)}}</span>
                  </template>
                  <template v-else>
                    <span class="ft_r">{{orderStatusTag(item.orderStatus)}}</span>
                  </template>
                </template>
                <template v-else>
                  <!--个人-->
                  <template v-if="item.refundStatus == 1 || item.refundStatus == 2">
                    <span class="ft_r">退款中 {{groupStatusTag(item.groupStatus)}}</span>
                  </template>
                  <template v-else-if="item.refundStatus == 4">
                    <span class="ft_r">{{groupStatusTag(item.groupStatus)}}</span>
                    <span class="ft_r" style="position: relative;margin-right: 20px;">
                      退款成功
                      <el-popover
                        placement="right"
                        trigger="hover"
                        width="100px">
                        <img slot="reference" class="question_icon" src="../../assets/question_icon.png">
                        <p>退款将在1-2个工作日内返回原付款账户，请留意</p>
                        <p>如有疑问请拨打客服热线400 6057 800</p>
                      </el-popover>
                    </span>
                  </template>
                  <template v-else>
                    <template v-if="item.payStatus == 1 || item.payStatus == 5">
                      <span class="ft_r">{{statusTag(item.status)}} {{groupStatusTag(item.groupStatus)}}</span>
                    </template>
                    <template v-else>
                      <span class="ft_r">{{payStatusTag(item.payStatus)}} {{groupStatusTag(item.groupStatus)}}</span>
                    </template>
                    <template v-if="item.refundStatus == 3 || item.refundStatus == 5">
                      <span class="ft_r" style="position: relative;margin-right: 20px;">
                        退款失败
                        <el-popover
                          placement="right"
                          trigger="hover"
                          width="100px"
                          content="如有疑问请拨打客服热线400 6057 800">
                          <img slot="reference" class="question_icon" src="../../assets/question_icon.png">
                        </el-popover>
                      </span>
                    </template>
                  </template>
                </template>
              </div>
              <el-table
                :data="item.orderDetailList"
                :span-method="objectSpanMethod"
                border
                style="width: 100%">
                <el-table-column
                  prop="itemName"
                  label="商品名称">
                </el-table-column>
                <el-table-column
                  prop="specPrice"
                  label="单价" min-width="30">
                </el-table-column>
                <el-table-column
                  prop="spec"
                  label="规格" min-width="30">
                </el-table-column>
                <el-table-column
                  prop="itemNum"
                  label="数量" min-width="30">
                </el-table-column>
              </el-table>

              <div class="order-item-footer">
                <div class="foots">
                    <div class="footz">
                      <img src="../../assets/shop.png">
                      <span>{{item.providerName}}</span>
                      <p>{{item.addTime}}</p>
                    </div>
                    <div class="footy"> 共计{{item.itemNumTotal}}件商品 &nbsp; 合计：<span>￥{{item.payPrice | FormatCurrency(item.payPrice)}}</span></div>
                </div>
                <div class="footx">
                  <!--<div class="footx_left">-->
                    <!--{{item.addTime}}-->
                  <!--</div>-->
                  <div class="footx_right">
                    <div style="margin-left: 5px;">
                      <el-button
                        class="btn_text"
                        v-if="item.payStatus == 0 && item.sampleStatus != 2 && item.sampleStatus != 3 && item.sampleStatus != 10"
                        @click.native.prevent="deleteRow(item.id)"
                        type="text"
                        size="small">
                        取消订单
                      </el-button>
                      <el-button
                        class="btn_text"
                        v-if="item.payStatus == 2 && item.sampleStatus != 2 && item.sampleStatus != 3 && item.sampleStatus != 10"
                        @click.native.prevent="destroyRow(item.id)"
                        type="text"
                        size="small">
                        删除订单
                      </el-button>
                      <el-button
                        @click.native.prevent="detailRow(item.id,item.itemNumTotal)"
                        v-if="item.payStatus == 0 && !isChannel"
                        class="pay">
                        支付
                      </el-button>
                      <el-button
                        @click.native.prevent="addOrUpdateHandle(item.orderDetailList[0].id, item.orderDetailList[0].itemId, item.id)"
                        type="text"
                        size="small"
                        v-if="item.payStatus == 1 && item.orderType == 1 && !item.sampleIdList.length && item.status < 7"
                        style="display: inline-block">
                        录入样本信息
                      </el-button>
                      <!--仅预约订单支持退款操作-->
                      <template v-if="item.apptStatus == 1 && !item.snStatusList.length">
                        <el-button
                          class="btn_text"
                          v-if="item.payStatus == 1"
                          @click.prevent="toRefund(item.id)"
                          type="text"
                          size="small">
                          申请退款
                        </el-button>
                        <div class="chaka red" @click.prevent="cancelRefund(item.id)" v-if="item.refundStatus == 1">取消退款</div>
                      </template>
                      <div class="chaka" @click.prevent="detailRow(item.id,item.itemNumTotal)">查看详情</div>
                      <div class="chaka" v-if="item.invoiceFlag === 1" @click="detailInvoice(item.orderNum)">查看发票</div>
                      <div class="chaka" v-else v-show="item.refundStatus !== 2" @click.prevent="toInvoice(item.orderNum)">开具发票</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="limit"
              layout="prev, pager, next, jumper"
              :total="totalCount"
              v-if="orderList.length"
              style="text-align:center">
            </el-pagination>
            <div class="empty" v-if="orderList.length==0 && !loading">
              当前没有订单信息哦
            </div>
          </el-main>

        </el-container>
      </el-container>
    </div>
    <pay-code-modal v-bind:c_mdshow='p_mdshow' v-on:c_close='p_close'>
      <p slot="msg">
        扫一扫微信支付
      </p>
      <img slot="code" class="code" :src="payCode" alt="">

      <div slot='btnGroup'>
        <a href="javascript:;" class='btn btn--m' @click='p_close'>取消</a>
      </div>
    </pay-code-modal>

    <!--标本信息弹框-->
    <sample-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataInfo()"></sample-add-or-update>

    <!--发票信息弹框-->
    <invoice-add-or-update v-if="invoiceVisible" ref="invoice" @refreshDataList="getDataInfo()"></invoice-add-or-update>

    <!--取消退款弹框-->
    <cancel-refund v-if="cancelRefundVisible" ref="cancelRefund" @refreshDataList="getDataInfo()"></cancel-refund>

    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import NavLeft from '@/components/NavLeft.vue'
  import '@/assets/css/index.css'
  import {getCookie, removeHTMLTag,delCookie} from "../../util/util";
  import PayCodeModal from "../../components/PayCodeModal";
  import SampleAddOrUpdate from '../../components/sample-add-or-update'
  import InvoiceAddOrUpdate from '../../components/invoice-add-or-update'
  import CancelRefund from '../../components/cancel-refund'

  export default {
    name: "mine",
    data() {
      return {
        addOrUpdateVisible: false,
        advertiseList: [],
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        limit: 5,
        page: 1,
        orderList: [],
        // user: {},
        p_activeIndex: "1",
        loading: true,
        totalPage: 0,
        totalCount: 0,
        currentPage: 1,
        maxDetailLength: 1,
        p_showSearch:true,
        p_loginModalFlag:false,
        p_showNavbar: true,
        isChannel:true,
        keyword:"",
        interval:{},
        p_mdshow:false,
        payStatus:0,
        payCode:'',
        options: [{
          value: '1',
          label: '代理商订单'
        },
        // {
        //   value: '2',
        //   label: '医院订单'
        // }
        ],
        value:this.$route.query.orderType && this.$route.query.orderType == 2 ? '医院订单' : '代理商订单',
        orderType:this.$route.query.orderType ? this.$route.query.orderType : 1,
        //查询时间段
        beginTime: '',
        dateRangeList: [
          {
            key: '',
            value: '不限时间'
          },
          {
            key: '1week',
            value: '近一周'
          },
          {
            key: '1month',
            value: '近一个月'
          },
          {
            key: '3month',
            value: '近三个月'
          },
          {
            key: '6month',
            value: '近半年'
          },
          {
            key: '1year',
            value: '近一年'
          }
        ],
        dateRange: '不限时间',
        historyOrder: false,
        isWeChat:false,
        code:'0',
        appid: '',
        payType:0,
        qrCodeFlag:1,
        // 发票
        invoiceVisible: false,
        // 订单状态
        statusList: [
          {
            status: 0,
            label: '未支付'
          },
          {
            status: 1,
            label: '待发货'
          },
          {
            status: 2,
            label: '已发货'
          },
          {
            status: 3,
            label: '待录入样本'
          },
          {
            status: 4,
            label: '录入中'
          },
          {
            status: 5,
            label: '待确认'
          },
          {
            status: 6,
            label: '已确认'
          },
          {
            status: 7,
            label: '已送样'
          },
          {
            status: 8,
            label: '已收样'
          },
          {
            status: 9,
            label: '检测中'
          },
          {
            status: 10,
            label: '报告生成'
          },
          {
            status: 11,
            label: '支付超时'
          },
          {
            status: 12,
            label: '取消订单'
          },
          {
            status: 13,
            label: '已拒绝'
          }
        ],
        orderStatusList: [
          {
            status: 0,
            label: '待确认'
          },
          {
            status: 1,
            label: '已确认'
          },
          {
            status: 2,
            label: '部分发货'
          },
          {
            status: 3,
            label: '全部发货'
          },
          {
            status: 4,
            label: '订单完成'
          },
          {
            status: 5,
            label: '客户取消'
          },
          {
            status: 6,
            label: '厂家取消'
          }
        ],
        groupStatusList: [
          // {
          //   status: '-1',
          //   label: '不参与'
          // },
          {
            status: '0',
            label: '拼团中'
          },
          {
            status: '1',
            label: '拼团中'
          },
          {
            status: '2',
            label: '拼团成功'
          },
          {
            status: '9',
            label: '拼团失败'
          }
        ],
        payStatusList: [
          {
            status: 0,
            label: '未支付'
          },
          {
            status: 1,
            label: '已支付'
          },
          {
            status: 2,
            label: '已取消'
          },
          {
            status: 3,
            label: '退款中'
          },
          {
            status: 4,
            label: '退款成功'
          },
          {
            status: 5,
            label: '退款失败'
          }
        ],
        // 退款状态
        refundStatusList: [
          {
            status: 0,
            label: '默认'
          },
          {
            status: 1,
            label: '申请中'
          },
          {
            status: 2,
            label: '申请成功'
          },
          {
            status: 3,
            label: '申请失败'
          },
          {
            status: 4,
            label: '处理完成'
          },
          {
            status: 5,
            label: '处理失败'
          },
          {
            status: 9,
            label: '取消申请'
          }
        ],
        cancelRefundVisible: false
      }
    },
    components: {
      PayCodeModal,
      SampleAddOrUpdate,
      InvoiceAddOrUpdate,
      CancelRefund,
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread,
      NavLeft
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      statusTag () {
        return function (code) {
          return (this.statusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      orderStatusTag () {
        return function (code) {
          return (this.orderStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      groupStatusTag () {
        return function (code) {
          return (this.groupStatusList.find(e => e.status === code) || { label: '' }).label
        }
      },
      payStatusTag () {
        return function (code) {
          return (this.payStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      refundStatusTag () {
        return function (code) {
          return (this.refundStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      }
    },
    watch: {
      'orderList': function(val) {
        if (!val.length && this.page > 1) {
          this.page = this.page - 1
          if(this.orderType == 1){
            this.getOrderList(this.isChannel)
          }else {
            this.getHospitalOrderList(this.isChannel)
          }
        }
      }
    },
    mounted() {
      // console.log(this.orderType)
      if (getCookie("_token")) {
        // let time = new Date(((new Date()).getTime() - (365 / 4 * 24 * 3600 * 1000)));
        // this.beginTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();

        if(this.user.isChannel == 1 || this.user.isChannel == 2){
          this.isChannel = true
          if(this.orderType == 1){
            this.getOrderList(this.isChannel)
          }else {
            this.getHospitalOrderList(this.isChannel)
          }
        }else{
          this.isChannel = false
          this.getOrderList(this.isChannel)
        }
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.p_showLoginModal()
      }
    },
    methods: {
      p_close(){
        this.p_mdshow = false;
        this.$message.error("支付已取消")
        // this.$router.replace("/mine/orderList")
        clearInterval(this.interval);
      },

      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
        if(this.user.isChannel == 1 || this.user.isChannel == 2){
          this.isChannel = true
          if(this.orderType == 1){
            this.getOrderList(this.isChannel)
          }else {
            this.getHospitalOrderList(this.isChannel)
          }
        }else{
          this.isChannel = false
          this.getOrderList(this.isChannel)
        }
      },

      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },

      handleCurrentChange(val) {
        this.page = val
        if(this.orderType == 1){
          this.getOrderList(this.isChannel)
        }else {
          this.getHospitalOrderList(this.isChannel)
        }
      },

      orderTypeChange(e){
        this.page = 1
        this.currentPage = 1
        this.orderType = e
        if(e == 1){
          this.getOrderList(true)
        }else{
          this.getHospitalOrderList(true)
        }
      },

      detailRow(id,itemNumTotal) {
        this.$router.push({path: "/mine/orderDesc", query: {id: id, orderType : this.orderType, itemNumTotal:itemNumTotal}})
      },

      deleteRow(id){
        this.$confirm('此操作将永久取消该订单, 是否继续?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.delOrder(id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已放弃取消订单'
          });
        });
      },

      destroyRow(id){
        this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.destroyOrder(id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已放弃删除订单'
          });
        });
      },

      //代理商取消自己的订单接口
      delOrder(orderId){
        let requestUrl = this.orderType == 1 ? "/jys/order/delete/" : "/jys/order/deleteChannelHospital/"
        axios.put(requestUrl + orderId,{},{
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((res) => {
          if(res.data.code == 0){
            this.$message({
              type: 'success',
              message: '取消订单成功!'
            });
            if(this.orderType == 1){
              this.getOrderList(this.isChannel)
            }else {
              this.getHospitalOrderList(this.isChannel)
            }
          }
        })
      },

      //代理商删除自己的订单接口
      destroyOrder(orderId){
        let requestUrl = this.orderType == 1 ? "/jys/order/destroy/" : "/jys/order/destroyChannelHospital/"
        axios.put(requestUrl + orderId,{},
        ).then((res) => {
          if(res.data.code == 0){
            this.$message({
              type: 'success',
              message: '删除订单成功!'
            });

            if(this.orderType == 1){
              this.getOrderList(this.isChannel)

            }else {
              this.getHospitalOrderList(this.isChannel)
            }

          }
        })
      },

      toPay(id){
        if(this.isWeChatFun()){
          this.isWeChat = true
          this.getAppid(id)
          //微信浏览器
          this.$confirm('请选择支付方式?', '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '微信支付',
            cancelButtonText: '生成二维码',
            type: 'warning',
            center: true,
            showClose: true
          }).then(() => {
            this.payType = 3
            this.qrCodeFlag = 0
            this.rePay(id)
          }).catch(action => {
            if(action === 'cancel'){
              window.scrollTo(0, 0)
              this.payType = 0
              this.qrCodeFlag = 1
              this.rePay(id)
            }else{
              this.$message.error('支付已取消')
            }
          });
        }else{
          window.scrollTo(0, 0)
          this.payType = 0
          this.qrCodeFlag = 1
          this.rePay(id)
        }
      },

      rePay(id){
        axios.put("/jys/pay/rePay",{
          orderId:id,
          code: this.code,
          payType: this.payType,
          qrCodeFlag: this.qrCodeFlag,
          orderPlatform: 1
        }).then((response)=>{
          if(response.data.code == 0){
            //普通用户下单成功
            this.loading = false
            let result = response.data.result
            let codeUrlPng = result.codeUrlPng
            let orderNo = result.orderNo
            if(this.payType == 3){
              if(typeof WeixinJSBridge == "undefined") {
                if(document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if(document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                  document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
              } else {
                this.onBridgeReady(result);
              }
            }else{
              this.p_mdshow = true
              this.payCode = 'data:image/png;base64,' + codeUrlPng
            }

            var interval = setInterval(() =>{
              this.getPayStatus(orderNo)
              if(this.payStatus == 1){
                clearInterval(interval);
                this.$message.success("支付成功")

                if(this.orderType == 1){
                  this.getOrderList(this.isChannel)

                }else {
                  this.getHospitalOrderList(this.isChannel)
                }

                this.p_mdshow = false;
              }
            }, 2000);

            this.interval = interval
          } else if (response.data.code == 500) {
            if (this.isWeChatFun()) {
              let href = location.href;
              let posit = href.indexOf("com/") + 4; //获取域名结束的位置
              let urlLeft = href.substring(0, posit);//url左侧部分
              let urlRight = href.split('#')[1]; //url右侧部分
              let url = urlLeft + "#" + urlRight;//拼接跳转
              window.history.pushState({}, 0, url)
            }
          }
        })
      },

      //获取订单支付状态
      getPayStatus(orderNo){
        axios.get("/jys/pay/status/" + orderNo,{
          headers:{
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          if(response.data.code == 0){
            let status = response.data.status
            this.payStatus = status
          }
        })
      },

      getOrderList(isChannel) {
        let orderUrl =isChannel ? "/jys/order/newChannel" : "/jys/order/new"
        axios.get(orderUrl, {
          params: {
            orderPlatform: 1,
            limit: this.limit,
            page: this.page,
            itemName: this.keyword,
            beginTime:this.beginTime
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          let res = response.data
          if(res.code == 0){
            this.loading = false
            this.orderList = res.page.list

            var detailLengthList = []
            for (var i = 0; i <  this.orderList.length; i++) {
              let orderDetailArr = this.orderList[i].orderDetailList
              let len = this.orderList[i].orderDetailList.length

              this.orderList[i].itemNumTotal = 0
              for (var j = 0; j < orderDetailArr.length; j++) {
                this.orderList[i].itemNumTotal += this.orderList[i].orderDetailList[j].itemNum
              }
              detailLengthList.push(len)
            }

            //获取最大行数,合并单元格
            this.maxDetailLength = Math.max.apply(null,detailLengthList)
            this.totalPage = res.page.totalPage
            this.totalCount = res.page.totalCount
            // this.currentPage = res.page.currPage
          }else if(res.code == 401){
            this.loading = false
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },

      //代理商获取医院的订单
      getHospitalOrderList(isChannel){
        // let orderUrl = "/jys/order/channelHospital"
        let orderUrl = isChannel ? "/jys/order/newChannel" : "/jys/order/new"
        axios.get(orderUrl, {
          params: {
            orderPlatform: 1,
            limit: this.limit,
            page: this.page,
            itemName:this.keyword,
            beginTime:this.beginTime
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          let res = response.data
          if(res.code == 0){
            this.loading = false
            this.orderList = res.page.list
            var detailLengthList = []
            for (var i = 0; i <  this.orderList.length; i++) {
              let orderDetailArr = this.orderList[i].orderDetailList
              let len = this.orderList[i].orderDetailList.length

              this.orderList[i].itemNumTotal = 0
              for (var j = 0; j < orderDetailArr.length; j++) {
                this.orderList[i].itemNumTotal += this.orderList[i].orderDetailList[j].itemNum
              }
              detailLengthList.push(len)
            }
            //获取最大行数,合并单元格
            this.maxDetailLength = Math.max.apply(null,detailLengthList)
            this.totalPage = res.page.totalPage
            this.totalCount = res.page.totalCount
            // this.currentPage = res.page.currPage
          }else if(res.code == 401){
            this.loading = false
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },

      //搜索
      inputKey(){
        if(this.keyword.length == 0 ){
          this.page = 1
          this.currentPage = 1

          if(this.user.isChannel == 1 || this.user.isChannel == 2){
            if(this.historyOrder){
              this.getOrderList(false)
            }else{
              this.isChannel = true
              if(this.orderType == 1){
                this.getOrderList(this.isChannel)
              }else {
                this.getHospitalOrderList(this.isChannel)
              }
            }
          }else{
            this.isChannel = false
            this.getOrderList(this.isChannel)
          }

        }
      },
      clearKey(){
        this.keyword = ""
        this.page = 1
        this.currentPage = 1

        if(this.user.isChannel == 1 || this.user.isChannel == 2){
          if(this.historyOrder){
            this.getOrderList(false)
          }else{
            this.isChannel = true
            if(this.orderType == 1){
              this.getOrderList(this.isChannel)
            }else {
              this.getHospitalOrderList(this.isChannel)
            }
          }
        }else{
          this.isChannel = false
          this.getOrderList(this.isChannel)
        }
      },

      search(){
        this.page = 1
        this.currentPage = 1

        if(this.user.isChannel == 1 || this.user.isChannel == 2){
          if(this.historyOrder){
            this.getOrderList(false)
          }else{
            this.isChannel = true
            if(this.orderType == 1){
              this.getOrderList(this.isChannel)
            }else {
              this.getHospitalOrderList(this.isChannel)
            }
          }
        }else{
          this.isChannel = false
          this.getOrderList(this.isChannel)
        }

      },

      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 4) {
          if (rowIndex % this.maxDetailLength === 0) {
            return {
              rowspan: this.maxDetailLength,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },

      //录入标本 路径;订单详情id;服务项目id;订单id;
      addOrUpdateHandle (detailItemId, itemId, orderId) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init('',detailItemId,itemId,orderId)
        })
      },

      //根据时间段搜索
      handleCommand(command) {
        // 先获取当前时间
        let curDate = (new Date()).getTime();
        let pastResult = '';

        if(command){
          if(command == '1week'){
            //近一周
            this.dateRange = '近一周'
            let dateTemp = 7 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;  // 毫秒单位

          }else if(command == '1month'){
            //近一个月
            this.dateRange = '近一个月'
            let dateTemp = 365 / 12 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '3month'){
            //近三个月
            this.dateRange = '近三个月'
            let dateTemp = 365 / 4 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '6month'){
            //近半年
            this.dateRange = '近半年'
            let dateTemp = 365 / 2 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '1year'){
            //近一年
            this.dateRange = '近一年'
            let dateTemp = 365 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }

          // 日期函数，定义起点为半年前
          let pastDate = new Date(pastResult);
          let pastYear = pastDate.getFullYear();
          let pastMonth = pastDate.getMonth() + 1;
          let pastDay = pastDate.getDate();

          if (pastMonth >= 1 && pastMonth <= 9) {
            pastMonth = "0" + pastMonth;
          }
          if (pastDay >= 0 && pastDay <= 9) {
            pastDay = "0" + pastDay;
          }

          this.beginTime = pastYear + '-' + pastMonth + '-' + pastDay;
        }else{

          this.dateRange = '不限时间'
          this.beginTime = ''
        }

        this.keyword = ''
        this.search()

      },

      getHistoryList (e) {
        this.keyword = ''
        this.dateRange = '近三个月'
        let time = new Date(((new Date()).getTime() - (365 / 4 * 24 * 3600 * 1000)));
        this.beginTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
        if(e){
          this.getOrderList(false)
        }else{
          this.search()
        }
      },

      //判断是否是微信浏览器
      isWeChatFun(){
        let ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          return true;
        }else{
          return false;
        }
      },
      //获取地址栏参数
      GetQueryString(name) {
        let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
      },
      //微信获取appid
      getAppid(id){
        axios.get("/jys/pay/appid", {
          params: {
            orderId: id
          }
        }).then((res) => {
          if (res.data.code === 0) {
            this.appid = res.data.appid
            this.getCode(res.data.appid)
          }
        })
      },
      //微信授权获取code
      getCode(appid){
        let code = this.GetQueryString('code')
        if(code != null && code.toString().length>1) {
          this.code = code
        }else{
          //redirect_uri授权后重定向的回调链接地址
          location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=0#wechat_redirect';
        }
      },
      //微信支付
      onBridgeReady(data){
        let that = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": data.appid,//公众号名称
            "timeStamp": data.timeStamp,//时间戳
            "nonceStr": data.nonceStr, //随机串
            "package": data.package,
            "signType":"MD5",//微信签名方式
            "paySign": data.paySign//微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ) {

            }else if(res.err_msg == "get_brand_wcpay_request:cancel") {
              that.reload()
            }else if(res.err_msg == "get_brand_wcpay_request:fail"){
              that.reload()
              that.$message.error(JSON.stringify(res))
            }else{
              that.reload()
            }
          }
        )
      },
      //重新加载
      reload(){
        let href = location.href;
        var posit = href.indexOf("com/") + 4; //获取域名结束的位置
        var urlLeft = href.substring(0, posit);//url左侧部分
        var urlRight = href.split('#')[1]; //url右侧部分
        location.href = urlLeft + "#" + urlRight;//拼接跳转
      },

      getDataInfo(){
        if(this.user.isChannel == 1 || this.user.isChannel == 2){
          this.isChannel = true
          if(this.orderType == 1){
            this.getOrderList(this.isChannel)
          }else {
            this.getHospitalOrderList(this.isChannel)
          }
        }else{
          this.isChannel = false
          this.getOrderList(this.isChannel)
        }
      },

      // 开具发票
      toInvoice (orderNum) {
        this.invoiceVisible = true
        this.$nextTick(() => {
          this.$refs.invoice.init(orderNum)
        })
      },

      //查看发票
      detailInvoice(orderNum) {
        this.invoiceVisible = true
        this.$nextTick(() => {
          this.$refs.invoice.init(orderNum)
        })
      },

      // 跳转到店铺
      toCompany(id) {
        this.$router.push({path: "/company/index", query: {id: id}})
      },

      // 退款
      toRefund(id) {
        this.$router.push({path: "/mine/applyRefund", query: {id: id, orderType: this.orderType}})
      },

      // 取消退款
      cancelRefund(orderNum) {
        this.cancelRefundVisible = true
        this.$nextTick(() => {
          this.$refs.cancelRefund.init(orderNum)
        })
      }
    }
  }
</script>

<style scoped>
  .el-dropdown{
    cursor: pointer;
  }

  .order-item {
    margin-bottom: 20px;
  }

  .order-item-title {
    /*width:100%;*/
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background-color: #F5F5F5;
    text-align: left;
  }

  .order-item-title .question_icon {
    position: absolute;
    top: 13px;
    right: -15px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  .total-price {
    display: block;
    color: #FE2042;
    font-size: 16px;
  }

  .empty {
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
    background-color: #fff;
  }

  .el-button--text{

  }
 .fr{
   float: right;
 }

  .order .el-input__inner {
    padding-left: 30px;
    text-align: center;
  }

  .order-item-footer{
       border: 1px solid #ebeef5;
    border-top: none;
    padding: 10px;
  }
  .foots{
    display: flex;font-size: 11px;
    margin-bottom: 5px;
    justify-content: space-between;
  }
  .footz{
    color: #999;
  }
  .footz img{
    width: 14px;
    height: 14px;
  }
  .footy span{
    color: red;
  }
  .footx{
    display: flex;
    justify-content: flex-end;
  }
  .footx_left{
    font-size: 12px;
    color: #999;
  }
  .footx_right{
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .chaka,.pay {
    display: inline-block;
    width: 66px;
    height: 26px;
    line-height: 26px;
    border-radius: 12px;
    /* margin-left: 10px; */
    vertical-align: middle;
    font-size: 11px;
    cursor: pointer;
    text-align: center;
    color: #03DAC4;
    border: 1px solid rgba(0, 197, 177, 1);
  }
  .chaka_disabled{
    border-color: #909399;
    color: #909399;
    cursor: not-allowed;
  }
  .pay{
    color:#FE2042;
    border: 0.5px solid #FE2042;
    line-height: 8px;
  }
  .red{
    color:#FE2042;
    border-color: #FE2042;
  }
  .mshow{
    display: none;}


  .ft_r{
    float: right;
    font-weight: bolder;
    color: #4A4A4A;
  }

  .order_time{
    font-weight: bolder;
    color: #4A4A4A;
  }

  .order_num{
    padding-left: 10px;
    color: #4A4A4A;
  }
  .el-button--primary {
      vertical-align: middle;box-sizing: content-box;
  }
  .btn_text {
    display: inline-block;
    color:#909399;
    font-size: 11px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container{
      width: 95%;
      margin: 0 auto 70px;
    }
    .el-col-12 {
       width: initial;
    }

    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .mshow{
    display: inline-block;}
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    .mhide{
        display: none;}
    /deep/ .el-container{
      margin-left: 0!important;
    }
    /deep/ .el-pagination button {
      min-width: initial;
    }
    /deep/ .el-pagination .btn-prev {
      padding-right: 0;
    }
    /deep/ .el-pagination{
      margin-left: 0px;
    }

    /deep/ .el-pagination .btn-next {
      padding-left: 0;
    }
    /deep/ .el-pagination__jump {
      margin-left: 0;
      display: none!important;
    }
    .order-item-title {
      padding: 0 6px;
      font-size: 12px;
    }
    .el-main{
      padding: 10px;
    }
    .total-price {
      white-space: nowrap;
      font-size: 12px;
    }
    .order-item-title span{
      display: inline-block;
      white-space: nowrap;
    }
    .order_num {
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /deep/ .el-dialog {
      width: 98%!important;
    }
    /deep/ .el-pager li {
      min-width: 32px;
    }
    .el-input{

      width: 190px!important;
    }
    /deep/ .header a{

      overflow: hidden;
      white-space: nowrap;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel,/deep/ .navbar-left-container .home{
      display: none!important;
    }
    /deep/ .out{
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
    /deep/ .el-button--text {
      line-height: 11px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/user/OrderList.vue